import { Box, Container, Divider, Paper, Stack, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { useAppSelector } from "../Common/_hooks/useAppSelector";
import DineroFactory from "dinero.js";
import SamplePack from "./SamplePack";
import ColorChart from "./ColorChart";
import StockProductCard from "../StockProduct/StockProductCard";
import ornamentsImageUrl from '@resources/img/theme/page/ornaments-1.svg?url';
import samplePackImageUrl from '@resources/img/items/stock_product-sample-pack.jpg';
import paperSamplePackImageUrl from '@resources/img/pages/sample-packs/paper-sample-pack.jpg';

export default function SamplePacks() {
  const [t] = useTranslation()

  const userCurrency = useAppSelector(state => state.get('userData').get('prefs').get('currency'))

  const pricePaper = useMemo(() => {
    return DineroFactory({
      amount: 500,
      currency: userCurrency
    })
  }, [userCurrency])

  return <Box component="div" sx={{
    backgroundImage: 'url(' + ornamentsImageUrl + ')',
    backgroundPosition: 'center',
    backgroundSize: '100%',
    pt: 6,
    pb: 15,
    flex: '1 0 auto',
  }}>
    <Container
      maxWidth="md"
    >
      <Helmet>
        <title>{t('Sample Packs')}</title>
      </Helmet>

      <Stack spacing={3}>
        <Typography variant="h1" textAlign="center">{t('Order sample packs')}</Typography>
        <Paper
          elevation={0}
        >
          <Stack
            divider={<Divider />}
          >
            <StockProductCard
              stockProductSlug="sample-pack"
              img={samplePackImageUrl}
              description={t('Choose from our natural fabric, synthetic fabric, combined fabric, and vegan leather sample packs to compare texture, weight, color, and print finish before ordering.')}
            />
            <SamplePack
              type="sample_pack_preprinted_paper"
              price={pricePaper}
              img={paperSamplePackImageUrl}
              title={t('Paper sample pack')}
              text={t('All of our current paper options for fine art prints so you can see the difference and decide what is best for your art. Also included is a sample of our notebook covers and paper options.')}
            />
            <ColorChart/>
          </Stack>
        </Paper>
      </Stack>
    </Container>
  </Box>
}
